import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";

import Img from "../../common/Img";

import db from "../../../services/query";

import { PopUpContext } from "../../../contexts/popUpContext";

import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../../common/ReportItemHeader";
import AttendanceList from "./AttendanceList";
import MainPrintLink from "../../common/MainPrint";

const AttendanceProfile = (props) => {
  const { sid } = props.match.params;

  const [activeSem, setSem] = useState(0);
  const [data, updateData] = useState([]);

  const { popUp } = useContext(PopUpContext);

  useEffect(async () => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `results/students/${sid}`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="results-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.student_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary results">
          <div className="wrapper">
            <p>{lbl.OverallCredits}</p>
            <h5>{`${data?.summary?.overall_credits || '-'}`}</h5>
          </div>
          <div className="wrapper">
            <p>ساعات درسی</p>
            <h5>{`${data?.summary?.overall_total_count || '-'}`}</h5>
          </div>
          <div className="wrapper">
            <p>حاضر</p>
            <h5>{`${data?.summary?.overall_present_count || '-'}`}</h5>
          </div>
          <div className="wrapper">
            <p>غیر حاضر</p>
            <h5>{`${data?.summary?.overall_absent_count || '-'}`}</h5>
          </div>
        </div>
        <div style={{display: "flex", marginLeft: "20px"}} className="controls">
          <MainPrintLink path={`student-attendance/${sid}/${activeSem}?lang=fa`} />
        </div>
      </div>
      <div className="results-report-area">
        <div className="report-container _75-per">
          <div className="report-table-area results">
            <AttendanceList activeSem={data?.data && data.data[activeSem]} />
          </div>
          <div className="student-info results">
            <div className="main-content-header">
              <div className={"right-content summary-card"}>
                <p className="summary-title">{"خلاصه سمستر" }</p>
              </div>
            </div>
            <div className="student-detail">
              <div className="detail_item">
                <p>مجموع کردت</p>
                <p>{data?.data && data?.data[activeSem]?.subjects_summary?.credits || '-' }</p>
              </div>
              <div className="detail_item">
                <p>ساعات درسی</p>
                <p>{data?.data && data?.data[activeSem]?.subjects_summary?.total_count || '-'}</p>
              </div>
              <div className="detail_item">
                <p>حاضر</p>
                <p>{data?.data && data?.data[activeSem]?.subjects_summary?.present_count  || '-'}</p>
              </div>
              <div className="detail_item">
                <p>غیر حاضر</p>
                <p>{data?.data && data?.data[activeSem]?.subjects_summary?.absent_count  || '-'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList data={data} setSem={setSem} activeSem={activeSem} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AttendanceProfile;
